// extracted by mini-css-extract-plugin
module.exports = {"carouselWrapper":"_3mKrf","carousel":"z47sm","showArrowsOnHover":"_3mmWI","arrow":"_1P8nH"};